const { VUE_APP_API_URL: API_BASE_URL } = process.env;

export * as ENDPOINTS from './endpoints';

export { API_BASE_URL };
